/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Plan_Free_CtaInputs */

const en_pricing_plan_free_cta = /** @type {(inputs: Pricing_Plan_Free_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Started`)
};

const de_pricing_plan_free_cta = /** @type {(inputs: Pricing_Plan_Free_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loslegen`)
};

const fr_pricing_plan_free_cta = /** @type {(inputs: Pricing_Plan_Free_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencer`)
};

const es_pricing_plan_free_cta = /** @type {(inputs: Pricing_Plan_Free_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comenzar`)
};

const it_pricing_plan_free_cta = /** @type {(inputs: Pricing_Plan_Free_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia`)
};

const nl_pricing_plan_free_cta = /** @type {(inputs: Pricing_Plan_Free_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aan de slag`)
};

const pl_pricing_plan_free_cta = /** @type {(inputs: Pricing_Plan_Free_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozpocznij`)
};

const fi_pricing_plan_free_cta = /** @type {(inputs: Pricing_Plan_Free_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aloita`)
};

const da_pricing_plan_free_cta = /** @type {(inputs: Pricing_Plan_Free_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kom i gang`)
};

const sv_pricing_plan_free_cta = /** @type {(inputs: Pricing_Plan_Free_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kom igång`)
};

/**
* | output |
* | --- |
* | "Get Started" |
*
* @param {Pricing_Plan_Free_CtaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_plan_free_cta = /** @type {((inputs?: Pricing_Plan_Free_CtaInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Plan_Free_CtaInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_plan_free_cta(inputs)
	if (locale === "fr") return fr_pricing_plan_free_cta(inputs)
	if (locale === "es") return es_pricing_plan_free_cta(inputs)
	if (locale === "it") return it_pricing_plan_free_cta(inputs)
	if (locale === "nl") return nl_pricing_plan_free_cta(inputs)
	if (locale === "pl") return pl_pricing_plan_free_cta(inputs)
	if (locale === "fi") return fi_pricing_plan_free_cta(inputs)
	if (locale === "da") return da_pricing_plan_free_cta(inputs)
	if (locale === "sv") return sv_pricing_plan_free_cta(inputs)
	return en_pricing_plan_free_cta(inputs)
});